import demoRow from 'src/link-components/demo-row';
import demoRowItem from 'src/link-components/demo-row-item';
import demoChild from './demo-child'
import {DocComponents} from "../doc-components/";

import icon from './icon/link-icon';
import button from './button/link-button';
import buttonGroup from './button/link-button-group';
import input from './input/link-input';
import collapse from './collapse/link-collapse';
import collapseGroup from './collapse/link-collapse-group';
import collapseTransition from './collapse/link-collapse-transition';
import radio from './radio/link-radio';
import radioGroup from './radio/link-radio-group';
import popover from './popover/pl-popover';
import dropdown from './dropdown/link-dropdown';
import dropdownItem from './dropdown/link-dropdown-item';
import select from './select/link-select';
import moveContainer from './move/link-move-container';
import moveItem from './move/link-move-item';
import tag from './tag/link-tag';
import tagInput from './tag/link-tag-input';
import segment from './segment/link-segment';
import pagination from './pagination/link-pagination';
import autoTable from './auto-table/link-auto-table';
import lovText from './lov/link-lov-text';
import lovSelect from './lov/link-lov-select';
import objectModal from './object/link-object-modal';

import renderFunc from './render/lv-render-func'
import slot from './render/lv-slot'
import scopeSlots from './render/lv-scope-slot'

import objectInput from './object/link-object-input';
import inputNumber from './input-number/link-input-number';
import justifyWrapper from './justify/link-justify-wrapper';
import justifyItem from './justify/link-justify-item';
import form from './form/link-form';
import formItem from './form/link-form-item';
import formColumn from './form/link-form-column';
import addressModal from './address/link-address-modal';
import addressInput from './address/link-address-input';
import slider from './slider/link-slider';
import sliderPreview from './slider/link-slider-preview';
import toggle from './toggle/link-toggle';
import mvgInput from './mvg/link-mvg-input';
import col from './grid/link-col';
import row from './grid/link-row';
import selectText from './select/link-select-text';
import tabs from './tabs/link-tabs'
import tab from './tabs/link-tab'
import doc from './doc/link-doc'
import markdown from './markdown/link-markdown'
import imgList from './img/link-img-list'
import img from './img/link-img'
import dialog from './dialog/link-dialog'
import tooltipText from './tooltip/pl-tooltip-text'
import navigatorMain from './navigator-main/pl-navigator-main'
import navigatorIframePage from './navigator-main/link-navigator-iframe-page'
import layout from './layout/link-layout'
import textarea from './textarea/link-textarea'
import staticTable from './static-table/link-static-table'
import radioLov from './radio/link-radio-lov'
import popper from './popper/pl-popper'
import popperTip from './popper-tip/link-popper-tip'
import timepicker from './datetime/time/pl-time'
import datepicker from './datetime/date/pl-date'
import scroll from './scroll/lv-scroll'
import textareaInput from './textarea/link-textarea-input'
import tree from './tree/link-tree'
import codemirror from './codemirror/link-codemirror'
import displaySourceCode from './display-source-code/link-display-source-code'
import pagebar from './pagination/link-pagebar'
import title from './title/link-title'
import loading from './loading/link-loading'
import loadingShadow from './loading/link-loading-shadow'
import singlePage from './navigator-main/link-single-page'
import formGrid from './form/link-form-grid'
import checkboxInner from './radio/link-checkbox-inner'
import radioInner from './radio/link-radio-inner'
import echarts from './echarts/link-echarts'

import exportModel from './export/link-export-modal'

import autoTableFilter from './auto-table/link-auto-table-filter'
import dynamicFilter from "./auto-table/dynamic-filter/link-dynamic-filter.vue";

import {filterComponents} from "./auto-table";
import {tableColumnComponents} from "./table-expansion";


/**
 * 这里一定得是标准的驼峰命名，之后会将驼峰命名转为横杠命名
 * @author weishengjian
 * @date 2018/11/14
 */
const components = {
	demoRow, demoRowItem, demoChild,
	...DocComponents, ...filterComponents, ...tableColumnComponents,

	renderFunc, slot, scopeSlots,

	icon, button, buttonGroup, input, collapseTransition, collapse, collapseGroup, radio, radioGroup,
	popover, dropdown, dropdownItem, select, moveContainer, moveItem, tag, tagInput,
	segment, datepicker, pagination, autoTable, inputNumber, justifyWrapper, justifyItem, form, formItem,
	formColumn, addressModal, addressInput, slider, sliderPreview, toggle, timepicker, selectText,
	tabs, tab, doc, markdown, popper, popperTip, scroll, textareaInput, codemirror, displaySourceCode, pagebar, title,
	loadingShadow, loading, singlePage, formGrid, checkboxInner, radioInner, echarts,

	lovText, lovSelect, radioLov,

	objectModal, objectInput, mvgInput, col, row, imgList, img, dialog, tooltipText, navigatorMain, navigatorIframePage, layout, textarea, staticTable, tree,

	autoTableFilter, dynamicFilter,

	exportModel,
};

export default components
